import { useState, useEffect } from 'react';
import { Dropdown } from './PrimereactComponents';
import type { DropdownChangeEvent } from 'primereact/dropdown';
import { useTranslation } from 'react-i18next';
import { useRouteLoaderData } from 'react-router-dom';
import './LanguageSelection.css';
import {ENABLE_I18N} from "../Constants";
import { DropdownLanguage } from '../api';

function LanguageSelection() {
    const LOCAL_STORAGE_KEY = 'lang';
    const { i18n } = useTranslation();
    const [showLanguageSelection] = useState(ENABLE_I18N);
    const loaderLanguages = (useRouteLoaderData('root') as DropdownLanguage[] | undefined) ?? [];
    const [selectedLanguage, setSelectedLanguage] = useState<DropdownLanguage | null>(null);

    //nacteni z localStorage pri startu
    useEffect(() => {
        const storedLangRaw = localStorage.getItem(LOCAL_STORAGE_KEY);
        if (!storedLangRaw) return;

        const storedLang = JSON.parse(storedLangRaw);
        const currentLang = (i18n.resolvedLanguage ?? i18n.language ?? 'cs');

        if (storedLang.code !== currentLang) {
            i18n.changeLanguage(storedLang.code);
        }
    }, []);

    //synchronizace
    useEffect(() => {
        if (!loaderLanguages.length) return;
        
        const current = loaderLanguages.find(l => l.language_code === i18n.language) || loaderLanguages[0];
        setSelectedLanguage(current);
        
        localStorage.setItem(LOCAL_STORAGE_KEY, JSON.stringify(current));
    }, [i18n.language, loaderLanguages]);

    const handleLanguageChange = (e: DropdownChangeEvent) => {
        const newLang = e.value as DropdownLanguage | null;
        if (newLang) {
            i18n.changeLanguage(newLang.language_code);
        }
    };

    const selectedValueTemplate = (option: DropdownLanguage | null) => {
        if (!option) return null;
        return <span>{option.language_code.toUpperCase()}</span>;
    };

    const optionItemTemplate = (option: DropdownLanguage) => {
        return <span>{option.name}</span>;
    };

    return (
        showLanguageSelection && (
            <Dropdown
                id='lngSelect'
                value={selectedLanguage}
                onChange={handleLanguageChange}
                options={loaderLanguages}
                optionLabel='name'
                valueTemplate={selectedValueTemplate}
                itemTemplate={optionItemTemplate}
                className='lng-selection'
            />
        )
    );
}

export default LanguageSelection;
